import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: block;
`;

export const CheckListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CheckList = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const CheckBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
`;

export const Terms = styled.label`
  ${({ theme }) => css`
    position: relative;
    width: calc(100% - 44px);
    margin-left: 12px;
    cursor: pointer;

    span {
      display: block;
      ${theme.fontStyle.text.body14_medium}
      color: ${theme.colors.neutral30};

      p {
        display: inline-block;
        color: #04e1ff;
      }

      &.required {
        &::after {
          content: '*';
          display: block;
          position: absolute;
          top: 0;
          left: -12px;
        }
      }
    }
  `}
`;
